import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";

export default {
  delegations: [],
  delegationsLoader: false,
  selectedRole: {},
  selectedUsers: [],
  users: [],
  usersLoader: false,
  callState: IResponseState.PENDING,
};
